import './styles/app.scss'
import BeetAPI from '@boite-beet/api-client'
import { createApp } from 'vue'
import { createGtag } from 'vue-gtag'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { Vue3Mq } from 'vue3-mq'

import App from '@/App.vue'
import langRouter from '@/extensions/langRouter'
import ScrollHub from '@/extensions/scollHub/index.js'
import i18n from '@/i18n/index.js'
import router from '@/router'
import store from '@/store'

const scrollingElement = document.scrollingElement || document.documentElement
const offset = window.innerHeight * 0.15

const app = createApp(App)
  .use(store)
  .use(router)
  .use(langRouter, 'fr')
  .use(BeetAPI, { store, apiUrl: import.meta.env.VITE_APP_API_URL })
  .use(ScrollHub, { scrollingElement, scrollEventTarget: window, reveal: { offset } })
  .use(i18n)
  .use(Vue3Mq, {
    breakpoints: {
      base: 0,
      sm: 566,
      md: 1024,
      lg: 1360,
      xl: 1440,
    },
    global: true,
  })

  .use(VueReCaptcha, { siteKey: import.meta.env.VITE_APP_GOOGLE_RECAPTCHA_KEY })

const gtag = import.meta.env.VITE_APP_GA_MEASUREMENT_ID
if (gtag) {
  app.use(
    createGtag({
      tagId: gtag,
      initMode: 'manual',
      pageTracker: { router },
    }),
  )
}

app.mount('#app')
